<template lang="pug">
.bookContentsPageComponent
  .navbar
    a.back( @click="onBackClick" )
      ui-svg-icon.backIcon(
        name="arrow-back"
        :size="16"
      )
      span Назад

  ui-loader(v-if="isLoading || !userItem")
  template(v-else)
    book-contents-component(:user-item="userItem")

</template>

<script>
import { computed, inject } from 'vue'
import ChildBookContentsController from '@/controllers/ChildBook/ChildBookContentsController'
import UserItemController from '@/controllers/UserItemController'
import BookContentsComponent from '@/components/Book/BookContents'
import { USER_ITEM_TYPE_BOOK } from '@/config'
import router from '@/router'

export default {
  components: {
    BookContentsComponent
  },
  props: {
    bookId: {
      type: Number,
      required: true
    }
  },
  setup (props) {
    const store = inject('store')

    const exit = () => router.replace({ name: 'Catalog' })

    let controller

    const defineChildBookController = () => {
      controller = ChildBookContentsController()
      controller.$on('requestChildBook-error', defineUserController) // if ChildBook 404 not found
      controller.setBookId(props.bookId)
    }

    const defineUserController = () => {
      controller = UserItemController()
      controller.$on('requestUserItem-error', exit)
      controller.requestUserItem(USER_ITEM_TYPE_BOOK, props.bookId)
    }

    if (store.user.isAuthenticated) {
      defineChildBookController()
    } else {
      defineUserController()
    }

    return {
      isLoading: computed(() => controller.isLoading).value,
      userItem: computed(() => controller?.userItem?.value ?? controller?.childBook?.value?.userItem ?? null)
    }
  },
  methods: {
    onBackClick () {
      const backURL = this.$router.options.history?.state?.back ?? ''
      if (backURL.match('/lesson/') || backURL.match('/books/')) {
        this.$router.replace({ name: 'BooksProgress' })
      } else {
        this.$router.go(-1)
      }
    }
  }
}
</script>

<style lang="sass" scoped>
.bookContentsPageComponent
  > .navbar
    margin-bottom: 6*$u
    > a
      width: fit-content
      display: flex
      align-items: center
      color: $cBlue
      cursor: pointer

      > span
        @include font('t16-medium')
        margin-left: 2.5*$u

      &:hover
        color: $cLightBlue
      &:active
        color: $cDarkBlue

  > .main
    display: flex
    @include gap2d(7.5*$u)

    > .leftSide
      height: fit-content
      flex: 0 0 102*$u
      @media (max-width: $XXXLWidth)
        flex: 0 0 84*$u
      @media (max-width: $padWidth)
        flex: 0 0 75*$u

    > .rightSide
      flex: 1
      height: fit-content
      border-radius: $brL
      background-color: $cWhite
      padding: 7.5*$u 9*$u

      > .title
        @include font('h1')
        margin-bottom: 5*$u

      > .contents
        display: flex
        flex-flow: column
        @include gap(5*$u, "column")

        > .chapter
          border-radius: $brM
          background-color: $cElements
          padding: 5*$u 7.5*$u

          > .title
            @include font('h2')
            margin-bottom: 2.5*$u

          > .lessons
            display: flex
            flex-flow: column
            align-items: stretch
            justify-content: space-between
            cursor: pointer
            @include gap(1.25*$u, "column")

            > .lesson
              @include font('t18-regular')
              display: flex
              @include gap(7*$u)
              align-items: flex-start
              justify-content: space-between
              cursor: pointer

              &._selected
                color: $cDarkBlue

              &:hover
                color: $cBlue

              > .label
                display: flex
                align-items: center

                > .icon
                  margin-left: 1*$u
                  color: $cYellow

@media (max-width: $XXXLWidth)
  .bookContentsPageComponent
    .main
      .rightSide
        padding: 4*$u

@media (max-width: $MWidth)
   .bookContentsPageComponent
    .main
      flex-direction: column
      .rightSide
        max-width: 100%
</style>
